module.exports = __webpack_public_path__ + "img/FR30066.2411a3c6.png";